import { PageType } from "@product/scmp-sdk";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";

export const pathname = "/page";

export const page = {
  route(query: QueryParameters<{ appBarVariant?: AppBarVariant; entityId: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Page } };
  },
};
